import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

export const UmrahInformation = () => {
  const { t } = useTranslation()
  return (
    <Paper
      className={s.container}
      padding={[12, 16, 12, 16]}
    >
      <p className={clsx('semi-bold-16', s.title)}>
        {t('umrah_block.information')}
      </p>

      <div className={s.box}>
        <p className={clsx('semi-bold-14', s.subtitle)}>{t('passport')}</p>

        <p className={clsx('medium-13', s.text)}>
          {t('umrah_block.passport_term')}
        </p>
      </div>

      <div className={s.divider} />

      <div className={s.box}>
        <p className={clsx('semi-bold-14', s.subtitle)}>
          {t('umrah_block.advance_payment')}
        </p>

        <p className={clsx('medium-13', s.text)}>
          {t('umrah_block.info_percentage')}
        </p>
      </div>
    </Paper>
  )
}
